import { Outlet, Navigate, useLocation } from 'react-router-dom';

export default function AuthenticatedRoute() {
    const isLoggedIn = localStorage.getItem('token');
    const location = useLocation();
    if (!isLoggedIn) {
        return (
            <Navigate
                to="/Login"
                state={{
                    from: location.pathname + location.search,
                }}
            />
        );
    }
    return <Outlet />;
}
